<template>
  <div>
    <div class="d-flex justify-end sticky to-header">
      <v-btn
        v-if="hasRight('DEVICE_WRITE')"
        v-bind="$config.buttonAttrs.floating"
        :to="{ name: 'NewBuildingLevel' }"
        title="Hozzáadás"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </div>

    <h1 class="py-6">Épület szintek</h1>

    <v-expansion-panels class="mb-4" :mandatory="!!Object.values(search).find((e) => e !== '')">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span>
            <v-icon left>mdi-filter</v-icon>
            Szűrés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col :cols="12" :sm="4" :md="3">
              <v-text-field
                v-model="search.name"
                @input="searchEventHandler"
                @click:clear="searchEventHandler"
                label="Név"
                clearable
              />
            </v-col>
            <v-col :cols="12" :sm="4" :md="3">
              <v-text-field
                v-model="search.building_name"
                @input="searchEventHandler"
                @click:clear="searchEventHandler"
                label="Épület megnevezés"
                clearable
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card>
      <v-data-table
        :loading="loading"
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps"
        calculate-widths
      >
        <template #[`item.actions`]="{ item }">
          <v-btn
            v-if="hasRight('DEVICE_WRITE')"
            small
            text
            fab
            dark
            depressed
            color="secondary"
            class="rounded-sm"
            :to="{ name: 'BuildingLevelEditor', params: { id: item.id }}"
            title="Szerkesztés"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn
            v-if="hasRight('DEVICE_WRITE')"
            text
            fab
            small
            color="secondary"
            class="rounded-sm m-3"
            @click="deleteBuildingLevel(item)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'BuildingLevelList',
      fetchItems: this.fetchBuildingLevels,
      dataTable: {
        options: {
          sortBy: ['name'],
        },
        headers: [
          { text: 'Megnevezés', value: 'name' },
          { text: 'Épület megnevezés', value: 'building_name' },
          { value: 'actions', sortable: false, align: 'end' }
        ],
      },
      search: {
        name: '',
        building_name: ''
      }
    };
  },

  methods: {
    parseSearchQueries() {
      return {
        name: this.$route.query.name,
        building_name: this.$route.query.building_name
      };
    },

    async fetchBuildingLevels() {
      this.loading = true;
      try {
        const response = await this.$http.post('building-levels/list', this.options);
        this.dataTable.items = response.building_levels;
        this.dataTable.itemsLength = response.building_levels_count;
        this.dataTable.options.page = this.$route.query.page*1 || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async deleteBuildingLevel(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> épület szint törlésére készül!<br>Folytatja?`,
        title: 'Figyelem',
      });

      if (!confirm) return;

      try {
        const response = await this.$http.get(`building-levels/delete/${item.id}`);
        this.fetchItems();
        if (response.status === 'OK') {
          this.$dialog.notify.info('Az épület szint törölve');
        }
      } catch (e) {
        console.error(e);
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
        building_name: this.search.building_name || ''
      };
    }
  }
};
</script>
